// Kept apart from datadog-rum so _app can ask "is this the funnel?" without
// pulling the RUM SDK into the main bundle.
// Exactly /cart, optionally behind a locale prefix (/fr/cart, /zh-Hant/cart).
// Not /collections/cart or any other nested */cart path.
export const isCartPage = (pathname: string) =>
  /^(\/[a-z]{2}(-[A-Za-z]+)?)?\/cart\/?$/.test(pathname);

// /checkout/<id> and /checkout/<id>/thank-you, optionally behind a locale
// prefix. Anchored so a collection handle like /collections/checkout/ doesn't
// count as the funnel.
export const isFunnelPage = (pathname: string) =>
  /^(\/[a-z]{2}(-[A-Za-z]+)?)?\/checkout\/[^/]+(\/thank-you)?\/?$/.test(
    pathname,
  ) || isCartPage(pathname);
